import { useIntl } from "react-intl";
import { Modal, Box, Checkbox,  Button, Grid} from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useEffect, useState } from "react";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
} from "../../services/serviceBase";
import CustomGridHeaderCell from "../ui/CustomGridHeaderCell";
import CustomTable from "../ui/CustomTable";
import CustomGridCell from "../ui/CustomGridCell";

const BoxQCModal = (props) => {
  const intl = useIntl();

  const modalStyle = {
    position: "relative",
    top: "40%",
    left: "45%",
    width: "85%",
    ml: "7%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
  };

  const { setLoading } = useLoading();

  const [boxQCData, setBoxQCData] = useState([]);
  const [boxQCDetails, setBoxQCDetails] = useState([]);
  const [columns, setColumns] = useState([]);

  const getBoxQCData = async () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/boxQC")
      .then((response) => {
        setLoading(false);
        setBoxQCData(response.data);

        var data = [];
        response.data.boxQCDetails.map((x) => {
          var item = x;
          item.boxQCId = x.boxBarcode + "-" + x.skuBarcode;
          data.push(item);
        });

        setBoxQCDetails(data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getColumns = () => {
    setColumns([
      {
        field: "boxBarcode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxQCDetails.BoxBarcode" })}
          />
        ),
        flex: 1,
        minWidth: 180,
      },
      {
        field: "skuBarcode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxQCDetails.SKUBarcode" })}
          />
        ),
        flex: 1,
        minWidth: 200,
      },
      {
        field: "outcome",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxQCDetails.Outcome" })}
          />
        ),
        flex: 1,
        minWidth: 80,
      },
      {
        field: "quantity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxQCDetails.Quantity" })}
          />
        ),
        flex: 1,
        minWidth: 80,
      },
      {
        field: "warehouse",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({
              id: "BoxQCDetails.Warehouse",
            })}
          />
        ),
        flex: 1,
        minWidth: 100,
      },
       {
        field: "location",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({
              id: "BoxQCDetails.Location",
            })}
          />
        ),
        flex: 1,
        minWidth: 100,
      },
       {
        field: "reason",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({
              id: "BoxQCDetails.Reason",
            })}
          />
        ),
        flex: 1,
        minWidth: 100,
      },
      {
        field: "dossierKey",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxQCDetails.DossierLink" })}
          />
        ),
        flex: 1,
        minWidth: 230,
      },
      {
        field: "isExtraQty",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxQCDetails.IsExtraQty" })}
          />
        ),
        flex: 1,
        renderCell: (params) => {
          return (
            <div>
              <Checkbox checked={params.row.isExtraQty} disabled={true} />
            </div>
          );
        },
      },
    ]);
  };

  useEffect(() => {
    if (
      props.idReturnFileHead !== null &&
      props.idReturnFileHead !== undefined &&
      props.idReturnFileHead !== "" &&
      props.openModal
    ) {
      getBoxQCData();
      getColumns();
    }
  }, [props.openModal]);

  const handleClose = () => {
    props.handleCloseModal();
    setBoxQCData([]);
    setBoxQCDetails([]);
  };

  const getBoxQCDataExtraction = async () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/boxQC/excel")
      .then((response) => {
        setLoading(false);
        window.open(response.data, "_blank");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Grid container>
          <Grid item md={6}>
        <PageHeader
          title={
            intl.formatMessage({ id: "BoxQCDetails.Title" }) +
            " - " +
            boxQCData.dossierKey
          }
        />
          </Grid>
          <Grid
            item
            md={6}
            sx={{ backgroundColor: "#bcb7b7", textAlign: "right" }}
          >
            <Button
              sx={{ color: "white" }}
              onClick={getBoxQCDataExtraction}
              disableRipple={true}
            >
              {" "}
              [{intl.formatMessage({ id: "BoxQCDetails.Extract" })}]{" "}
            </Button>
          </Grid>
        </Grid>
        {boxQCData !== null && boxQCData != [] ? (
          <CustomTable
            columns={columns}
            rows={boxQCDetails}
            id={"boxQCId"}
            rowHeight={50}
            headerHeight={50}
            tableHeight={420}
          />
        ) : (
          ""
        )}
      </Box>
    </Modal>
  );
};

export default BoxQCModal;
